import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { ProdutosPage } from "@/pages/ProdutosPage";
import { ProdutoDetailPage } from "@/pages/ProdutoDetailPage";
import { EstoquePage } from "@/pages/EstoquePage";
import { EstoqueDetailPage } from "@/pages/EstoqueDetailPage";
import { ClientesPage } from "@/pages/ClientesPage";
import { VendedoresPage } from "@/pages/VendedoresPage";
import { ContratosPage } from "@/pages/ContratosPage";
import { AlugueisPage } from "@/pages/AlugueisPage";
import { NovoAluguelPage } from "@/pages/NovoAluguelPage";
import { NovoAluguelAdminPage } from "@/pages/NovoAluguelAdminPage";
import { VerAlugueisPage } from "@/pages/VerAlugueisPage";
import { RetiradaPage } from "@/pages/RetiradaPage";
import { DevolucaoPage } from "@/pages/DevolucaoPage";
import { ManutencaoPage } from "@/pages/ManutencaoPage";
import { TagsPage } from "@/pages/TagsPage";
import { ComissoesPage } from "@/pages/ComissoesPage";
import { TaxasComissaoPage } from "@/pages/TaxasComissaoPage";
import { NotasFiscaisPage } from "@/pages/NotasFiscaisPage";
import { NotasComerciaisPage } from "@/pages/NotasComerciaisPage";
import { ExportacaoFiscalPage } from "@/pages/ExportacaoFiscalPage";
import { FormaturasPage } from "@/pages/FormaturasPage";
import { NotFound } from "@/pages/NotFound";
import { RouteErrorBoundary } from "@/shared/components/RouteErrorBoundary";
import { ProtectedRoute } from "@/features/auth/guards/ProtectedRoute";
import { RoleBasedRoute } from "@/features/auth/guards/RoleBasedRoute";
import { ACTIONS } from "@/constants/roles";
import { ROUTES } from "@/constants/routes";

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: ROUTES.HOME,
        element: <Navigate to={ROUTES.DASHBOARD} replace />,
      },
      {
        path: ROUTES.DASHBOARD,
        element: (
          <RoleBasedRoute permission={ACTIONS.dashboard.read}>
            <DashboardPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.PRODUCTS,
        element: (
          <RoleBasedRoute permission={ACTIONS.products.read}>
            <ProdutosPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.PRODUCT_DETAIL,
        element: (
          <RoleBasedRoute permission={ACTIONS.products.readDetail}>
            <ProdutoDetailPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.STOCK,
        element: (
          <RoleBasedRoute permission={ACTIONS.stock.read}>
            <EstoquePage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.STOCK_DETAIL,
        element: (
          <RoleBasedRoute permission={ACTIONS.stock.read}>
            <EstoqueDetailPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.CLIENTS,
        element: (
          <RoleBasedRoute permission={ACTIONS.clients.read}>
            <ClientesPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.SELLERS,
        element: (
          <RoleBasedRoute permission={ACTIONS.sellers.read}>
            <VendedoresPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.CONTRACTS,
        element: (
          <RoleBasedRoute permission={ACTIONS.contracts.read}>
            <ContratosPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.RENTALS,
        element: (
          <RoleBasedRoute permission={ACTIONS.rentals.delete}>
            <AlugueisPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.RENTAL_CREATE,
        element: (
          <RoleBasedRoute permission={ACTIONS.rentals.createUser}>
            <NovoAluguelPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.RENTAL_CREATE_ADMIN,
        element: (
          <RoleBasedRoute permission={ACTIONS.rentals.createAdmin}>
            <NovoAluguelAdminPage />
          </RoleBasedRoute>
        ),
        errorElement: <RouteErrorBoundary />,
      },
      {
        path: ROUTES.RENTALS_VIEW,
        element: (
          <RoleBasedRoute permission={ACTIONS.rentals.viewUser}>
            <VerAlugueisPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.RENTAL_PICKUP,
        element: (
          <RoleBasedRoute permission={ACTIONS.rentals.pickup}>
            <RetiradaPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.DEVOLUTIONS,
        element: (
          <RoleBasedRoute permission={ACTIONS.devolutions.read}>
            <DevolucaoPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.MAINTENANCES,
        element: (
          <RoleBasedRoute permission={ACTIONS.maintenances.read}>
            <ManutencaoPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.TAGS,
        element: (
          <RoleBasedRoute permission={ACTIONS.tags.read}>
            <TagsPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.COMMISSIONS,
        element: (
          <RoleBasedRoute permission={ACTIONS.commissions.read}>
            <ComissoesPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.COMMISSION_RATES,
        element: (
          <RoleBasedRoute permission={ACTIONS.commissionRates.read}>
            <TaxasComissaoPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.INVOICES,
        element: (
          <RoleBasedRoute permission={ACTIONS.invoices.read}>
            <NotasFiscaisPage />
          </RoleBasedRoute>
        ),
      },
      {
        path: ROUTES.COMMERCIAL_INVOICES,
        element: (
          <RoleBasedRoute permission={ACTIONS.commercialInvoices.read}>
            <NotasComerciaisPage />
          </RoleBasedRoute>
        ),
        errorElement: <RouteErrorBoundary />,
      },
      {
        path: ROUTES.FISCAL_EXPORT,
        element: (
          <RoleBasedRoute permission={ACTIONS.fiscalExport.read}>
            <ExportacaoFiscalPage />
          </RoleBasedRoute>
        ),
        errorElement: <RouteErrorBoundary />,
      },
      {
        path: ROUTES.GRADUATIONS,
        element: (
          <RoleBasedRoute permission={ACTIONS.graduations.read}>
            <FormaturasPage />
          </RoleBasedRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
